"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _kebabToPascal = _interopRequireDefault(require("./kebab-to-pascal"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function kebabToCamel(s) {
  if ('string' !== typeof s) {
    return s;
  }

  var p = (0, _kebabToPascal["default"])(s);
  return p.substr(0, 1).toLowerCase() + p.substring(1);
}

var _default = kebabToCamel;
exports["default"] = _default;